export default {
  baseDomainUrl: 'mon-marche.fr',
  BRAND_NAME: 'Mon Marché',
  SITE_URL: 'https://www.mon-marche.fr',
};
